<style scoped lang='less'>
.cx-layout{position:absolute; left:0; top:0; right:0; bottom:0; padding:0; margin:0;}
/* 整体缩放 */
.cx-wrap-scale{position:absolute; left:0; top:0; width:100%; height:100%;overflow-y: scroll;overflow-x: hidden;}
#cx-scale{--scalex:1; --scaley:1;}
.cx-scale{position:absolute; left:0; top:0; transform:scale(var(--scalex), var(--scaley));}
.el-button{position:fixed;bottom: 10px;right: 20px;float: right; z-index: 99; width: 70px;font-size: 13px;border-radius: 5px;background-color: #ECF6FF;}
</style>

<template>
  <div class="cx-wrap-scale">
    <div v-wechat-title="$route.meta.title"></div>
    <ScaleBox>
      <div class="cx-layout">
        <HeadNavApp id="main"></HeadNavApp>
        <router-view></router-view>
        <el-button @click="top">回到网页顶端</el-button>
        <Footer></Footer>
      </div>
    </ScaleBox>
  </div>
</template>

<script>
/* 插件-主布局 */
import HeadNavApp from './KYhadnavApp'
import Footer from '../project/Footer.vue'
import ScaleBox from '../assembly/ScaleBox.vue'
export default {
  components: {HeadNavApp, Footer, ScaleBox},
  mounted()
  {
    let path = this.$route.name
    let menu = document.querySelector('.menu')
    if (path === 'ProductView' || path === 'QXdetails')
      menu.style.display = 'none'
    else
      menu.style.display = 'block'
  },
  methods:
  {
    top()
    {
      document.querySelector('#main') && document.querySelector('#main').scrollIntoView({ block: 'start', behavior: 'smooth' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/layout/KYhomeApp.vue